// One account preference read by several mounts at once (the create hub and
// the Progress card both read the rest choice): a write in one reaches the
// others, so no mount builds with a value the athlete already changed.

type Listener = (raw: string) => void;

const listeners = new Map<string, Set<Listener>>();

/** Hear the writes to `key`. Returns the unsubscribe. */
export const onAccountPref = (key: string, listener: Listener): (() => void) => {
  const set = listeners.get(key) ?? new Set<Listener>();
  set.add(listener);
  listeners.set(key, set);
  return () => {
    set.delete(listener);
    if (set.size === 0) listeners.delete(key);
  };
};

/** Tell every reader of `key` about a write. */
export const emitAccountPref = (key: string, raw: string): void => {
  for (const l of listeners.get(key) ?? []) l(raw);
};
